import React from 'react';
import moment from 'moment';

interface DayHeaderProps {
  date: string;
  spacing: number;
  viewType: string;
}

export const DayHeader: React.FC<DayHeaderProps> = ({
  date,
  spacing,
  viewType,
}) => {
  const dayNumber = moment(date).format('D');
  const weekDay = moment(date).format('ddd');
  const showWeekday = (viewType === 'weekly');
  
  return (
    <div
      className="flex flex-col items-center justify-center relative border-b border-gray-300 dark:border-[#2d3748] border-r border-r-gray-300 dark:border-r-[#2d3748]"
      style={{
        width: spacing,
        height: showWeekday ? 45 : 35,
        minWidth: spacing
      }}
    >
      <span className="text-xs text-gray-700 dark:text-white">{dayNumber}</span>
      {showWeekday && (
        <span className="text-xs text-gray-500 dark:text-gray-400 mt-1 uppercase">{weekDay}</span>
      )}
    </div>
  );
}; 